import { Filter, RotateCcw, Search, ListOrdered, ArrowUp, ArrowDown, ArrowUpDown, Download } from "lucide-react";
import { useState, useMemo } from "react";
import "../../../../assets/style/modal-print.css";
import { fetchGetPiutangStatus } from "../../../../controller/dashboard/Loket";
import * as XLSX from "xlsx";

export const OldLppStatus = () => {
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);

    const requestSort = (key: string) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const [statusFilter, setStatusFilter] = useState<any>({
        status      : 'all',
        kecamatan   : 'all',
        desa        : 'all',
        klasf       : 'all',
        pelanggan   : 'all',
    });

    const [statusLength, setStatusLength] = useState('10');

    // --- STATE UNTUK PRE-FILTER DAN HOLD DATA ---
    const [dataPiutangStatus, setDataPiutangStatus] = useState<any[]>([]);

    const [isDataDisplayed, setIsDataDisplayed] = useState(false);

    const [filterBulan, setFilterBulan] = useState<string>('');
    const [filterTahun, setFilterTahun] = useState<string>('');
    const [kecamatan, setKecamatan] = useState<string>('');
    const [statusPiutang, setStatusPiutang] = useState<string>('');
    // -----------------------------------
    const uniqueDesa = Array.from(new Set(dataPiutangStatus.map(item => item.desa))).filter(Boolean);
    const uniqueKlas = Array.from(new Set(dataPiutangStatus.map(item => item.klasf))).filter(Boolean);

    const filteredPhotoMeters = dataPiutangStatus.filter(plg => {
    const searchLower = searchTerm.toLowerCase();

    const matchesSearch =
            (plg.nama?.toLowerCase() || '').includes(searchLower) ||
            (plg.nsb || '').includes(searchTerm) ||
            (plg.kecamatan || '').includes(searchTerm) ||
            (plg.desa || '').includes(searchTerm) ||
            (plg.klasf || '').includes(searchTerm)

        const matchesStatus =
            (!statusFilter.status || statusFilter.status === 'all' || plg.status === statusFilter.status) &&
            (!statusFilter.kecamatan || statusFilter.kecamatan === 'all' || plg.kecamatan === statusFilter.kecamatan) &&
            (!statusFilter.klasf || statusFilter.klasf === 'all' || plg.klasf === statusFilter.klasf) &&
            (!statusFilter.desa || statusFilter.desa === 'all' || plg.desa === statusFilter.desa);

        return matchesSearch && matchesStatus;
    });

    const sortedPhotoMeters = [...filteredPhotoMeters].sort((a, b) => {
        if (!sortConfig) return 0;

        const { key, direction } = sortConfig;

        let aValue = a[key] ?? '';
        let bValue = b[key] ?? '';

        // Deteksi otomatis jika valuenya adalah angka (meskipun di dalam string)
        const numA = Number(aValue);
        const numB = Number(bValue);

        if (!isNaN(numA) && !isNaN(numB) && aValue !== '' && bValue !== '') {
            aValue = numA;
            bValue = numB;
        } else {
            // Jika teks, ubah ke lowercase agar sorting tidak case sensitive
            aValue = aValue.toString().toLowerCase();
            bValue = bValue.toString().toLowerCase();
        }

        if (aValue < bValue) {
            return direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    const itemsPerPage = statusLength === 'all'
        ? (filteredPhotoMeters.length > 0 ? filteredPhotoMeters.length : 1)
        : Number(statusLength);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = sortedPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const applyFilters = async () => {
        const response : any = await initDataPiutangStatus(filterBulan, filterTahun, kecamatan, statusPiutang);

        let filtered = response.filter((item: any) => {
            const ket = item.keterangan || "";
            return ket.toLowerCase() === 'piutang' || ket.toLowerCase() === 'lunas';
        });

        setDataPiutangStatus(filtered);
        setIsDataDisplayed(true);
    };

    const handleTampilkan = async () => {
        setDataPiutangStatus([]);
        await applyFilters();
    };

    const handleDownloadExcel = () => {
        if (sortedPhotoMeters.length === 0) return;

        const columns = Object.keys(sortedPhotoMeters[0]);
        const rows = sortedPhotoMeters.map((item) =>
            columns.reduce<Record<string, any>>((row, column) => {
                row[column] = item[column] ?? '';
                return row;
            }, {})
        );
        const worksheet = XLSX.utils.json_to_sheet(rows, { header: columns });
        worksheet['!cols'] = columns.map((column) => ({
            wch: Math.min(
                40,
                Math.max(
                    column.length,
                    10,
                    ...rows.map((row) => String(row[column] ?? '').length)
                ) + 2
            ),
        }));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Status Piutang');
        XLSX.writeFile(
            workbook,
            `status-${filterBulan || 'semua'}-${filterTahun || 'semua'}.xlsx`
        );
    };

    const initDataPiutangStatus = async (bulan : string, tahun : string, kecamatan : string, statusPiutang : string) => {
        setLoading(true);
        try {
            const res = await fetchGetPiutangStatus(bulan, tahun, kecamatan, statusPiutang);
            if (res.status === 200 && Array.isArray(res.data)) {

                const processedData = res.data.map((item: any) => {
                return {
                    no: 0,
                    nama        : item.NAMA?.trim() || "",
                    nsb         : item.NSB || "",
                    alamat      : item.ALAMAT || "",
                    klasf       : item.KLAS || "",
                    total       : item.TOTAL_BYR || "",
                    tgl_byr     : item.TGLBYRTGL || "",
                    // // Tambahkan field di bawah ini agar filter bisa bekerja
                    keterangan  : item.KETERANGAN || "",
                    hair        : item.HAIR || "",
                    adm         : item.ADM || "",
                    denda       : item.DENDA || "",
                    desa        : item.DESA || ""
                }});

                return processedData;
            } else {
                console.error("Invalid response data:", res.data);
                setDataPiutangStatus([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setDataPiutangStatus([]);
        } finally {
            setLoading(false);
        }
    };

    const RenderTablePhotoMeterPelanggan = ({ filteredData, startIndex }: {
        filteredData: any[] | null;
        startIndex: number;
    }) => {
        return(<>
            {
            filteredData && filteredData.length > 0 ? (
                filteredData.map((plg, idx) => (
                <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">{startIndex + idx + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{plg.nama}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{plg.nsb}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{plg.alamat}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{plg.klasf}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{plg.keterangan}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Intl.NumberFormat("id-ID", {style: "currency",currency: "IDR", minimumFractionDigits: 0, }).format(Number(plg.total) || 0)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Intl.NumberFormat("id-ID", {style: "currency",currency: "IDR", minimumFractionDigits: 0, }).format(Number(plg.hair) || 0)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Intl.NumberFormat("id-ID", {style: "currency",currency: "IDR", minimumFractionDigits: 0, }).format(Number(plg.adm) || 0)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Intl.NumberFormat("id-ID", {style: "currency",currency: "IDR", minimumFractionDigits: 0, }).format(Number(plg.denda) || 0)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{plg.tgl_byr}</td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan={18} className="text-center py-4 text-gray-500">
                    Tidak ada data
                </td>
                </tr>
            )
            }
        </>);
    };


    const renderSortableHeader = (label: string, sortKey: string) => {
        return (
            <th
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-200 select-none transition-colors"
                onClick={() => requestSort(sortKey)}
            >
                <div className="flex items-center space-x-1">
                    <span>{label}</span>
                    {sortConfig?.key === sortKey ? (
                        sortConfig.direction === 'asc' ? <ArrowUp className="w-3 h-3 text-blue-600" /> : <ArrowDown className="w-3 h-3 text-blue-600" />
                    ) : (
                        <ArrowUpDown className="w-3 h-3 opacity-30" />
                    )}
                </div>
            </th>
        );
    };



    // ======================================================================================================================================================================================================================
    return (
      <>
        {/* PRE-FILTER SECTION */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <h2 className="text-lg font-semibold mb-4 text-gray-800">Filter Tampilan Piutang</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Bulan</label>
                    <select
                      value={filterBulan}
                      onChange={(e) => setFilterBulan(e.target.value)}
                      className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">Pilih Bulan</option>
                        {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map((bulan, idx) => (
                            <option key={idx} value={bulan}>{bulan}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Tahun</label>
                    <select
                      value={filterTahun}
                      onChange={(e) => setFilterTahun(e.target.value)}
                      className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">Pilih Tahun</option>
                        {["2018","2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026"].map((tahun, idx) => (
                            <option key={idx} value={tahun}>{tahun}</option>
                        ))}
                    </select>
                </div>

            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end py-2">
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Kecamatan</label>
                    <select
                      value={kecamatan}
                      onChange={(e) => setKecamatan(e.target.value)}
                      className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">Pilih Kecamatan</option>
                        {[
                            "BUNTULIA", "DENGILO", "DUHIADAA", "LEMITO", "MARISA", "PAGUAT", "PATILANGGIO",
                            "POPAYATO", "POPAYATO BARAT", "POPAYATO TIMUR", "RANDANGAN", "TALUDITI", "WANGGARASI"
                        ].map((kec, idx) => (
                            <option key={idx} value={kec}>{kec}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Status Piutang</label>
                    <select
                      value={statusPiutang}
                      onChange={(e) => setStatusPiutang(e.target.value)}
                      className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="">Pilih Status Piutang</option>
                        {[ "Lunas", "Piutang" ].map((kec, idx) => (
                            <option key={idx} value={kec}>{kec}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 items-end py-3">
                <div>
                    <button
                        onClick={handleTampilkan}
                        disabled={loading}
                        className="w-full flex justify-center items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:bg-blue-400"
                    >
                        {loading ? "Memuat Data..." : "Tampilkan Data"}
                    </button>
                </div>
            </div>
        </div>

        {/* HANYA TAMPILKAN TABEL JIKA "isDataDisplayed" TRUE */}
        {isDataDisplayed && (
            <div className="animate-fade-in">

                {/* Controls 2 */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                        <button
                            // onClick={initDataPhotoMeter}
                            disabled={loading}
                            className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                            <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                            {loading ? "Memuat..." : "Muat Ulang"}
                        </button>

                        <button
                            onClick={handleDownloadExcel}
                            disabled={loading || sortedPhotoMeters.length === 0}
                            className="flex items-center px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-300"
                        >
                            <Download className="w-4 h-4 mr-2" />
                            Download Excel
                        </button>

                        

                        </div>

                        <div className="flex space-x-3">
                            <div className="relative">
                                <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <select
                                value={statusFilter.klasf}
                                onChange={(e) => setStatusFilter({ ...statusFilter, klasf: e.target.value })}
                                className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                <option value="all">Klas</option>
                                {uniqueKlas.map((klasf, idx) => (
                                    <option value={String(klasf)} key={idx}>{klasf}</option>
                                ))}
                                </select>
                            </div>

                            <div className="relative">
                                <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <select
                                    value={statusFilter.desa}
                                    onChange={(e) => setStatusFilter({ ...statusFilter, desa: e.target.value })}
                                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    >
                                    <option value="all">Desa</option>
                                    {uniqueDesa.map((desa, idx) => (
                                        <option value={String(desa)} key={idx}>{desa}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                type="text"
                                placeholder="Cari nama atau NSB..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                                />
                            </div>

                            <div className="relative">
                                <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <select
                                    value={statusLength}
                                    onChange={(e) => {
                                        setStatusLength(e.target.value);
                                        setCurrentPage(1); // Tambahkan ini agar tabel otomatis kembali ke page 1
                                    }}
                                    className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                                >
                                    <option value="10">10</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                    <option value="all">Tampil Semua</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Employee Table */}
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NO</th>
                            {renderSortableHeader("NAMA", "nama")}
                            {renderSortableHeader("NSB", "nsb")}
                            {renderSortableHeader("ALAMAT", "alamat")}
                            {renderSortableHeader("KLASF", "klasf")}
                            {renderSortableHeader("PELANGGAN", "keterangan")}
                            {renderSortableHeader("TOTAL", "total")}
                            {renderSortableHeader("HAIR", "hair")}
                            {renderSortableHeader("ADM", "adm")}
                            {renderSortableHeader("DENDA", "denda")}
                            {renderSortableHeader("TGL BYR", "tgl_byr")}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                            loading?
                            <tr>
                                <td colSpan={18} className="text-center py-4 text-gray-500">Sedang Loading . . .</td>
                            </tr>
                            :
                            <RenderTablePhotoMeterPelanggan filteredData={currentPhotoMeters} startIndex={indexOfFirstItem} />
                        }
                    </tbody>
                    </table>
                </div>
                </div>

                {/* Pagination */}
                <div className="mt-6 flex items-center justify-between">
                    <div className="text-sm text-gray-700">
                    Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
                    <span className="font-medium">{statusLength === "all" ? filteredPhotoMeters.length : Math.min(currentPage * itemsPerPage, filteredPhotoMeters.length)}</span> dari{' '}
                    <span className="font-medium">{filteredPhotoMeters.length}</span> data
                    </div>
                    <div className="flex space-x-2">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(1)}
                        className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                        First
                    </button>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(prev => prev - 1)}
                        className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                        Previous
                    </button>

                    {pageNumbers
                    .slice(
                        Math.max(0, currentPage - 3),
                        Math.min(currentPage + 2, totalPages)
                    )
                    .map((page) =>(
                        <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                        {page}
                        </button>
                    ))}

                    <button
                        disabled={currentPage >= totalPages}
                        onClick={() => setCurrentPage(prev => prev + 1)}
                        className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                        Next
                    </button>
                    <button
                        disabled={currentPage >= totalPages || totalPages === 0}
                        onClick={() => setCurrentPage(totalPages)}
                        className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                        Last
                    </button>
                    </div>
                </div>
            </div>
        )}
      </>
    )
};